<template>
  <!-- 数字化服务列表页面 -->
  <div class="serviceList">
    <!-- 顶部banner背景图 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
    </div>
    <!-- 搜索框 -->
    <div class="serviceSearch">
      <div class="greatField-con-search">
        <el-input
          placeholder="请输入解决方案"
          v-model="caseName"
          @keyup.native.enter="query()"
          ref="search"
        >
          <template slot="append">
            <div class="greatField-con-search-icon" @click="query()"></div>
          </template>
        </el-input>
      </div>
    </div>
    <div class="service-con">
      <!-- 服务切换 -->
      <div class="service-top">
        <div
          class="service-top-item"
          @click="clickSpecial"
          :class="serviceIndex == 0 ? 'service-cur' : ''"
        >
          <div v-show="serviceIndex == 0" class="triangle"></div>
          <div class="service-top-title">特色服务（{{ featureNum }}）</div>
          <div class="service-top-type">
            <span class="typeItem" @click="clickType('')">
              全部
              <span v-show="typeId == ''" class="mark"></span>
            </span>
            <span
              v-for="item in featureTypeList"
              :key="item.id"
              class="typeItem"
              @click="clickType(item.id)"
            >
              {{ item.program }}
              <span v-show="typeId == item.id" class="mark"></span>
            </span>
          </div>
        </div>
        <div
          class="service-top-item"
          @click="clickCommon"
          :class="serviceIndex == 1 ? 'service-cur' : ''"
        >
          <div v-show="serviceIndex == 1" class="triangle"></div>
          <div class="service-top-title">公共服务（{{ commonNum }}）</div>
          <div class="service-top-type">
            <span class="typeItem" @click="clickType('')">
              全部
              <span v-show="typeId == ''" class="mark"></span>
            </span>
            <span
              v-for="item in commonTypeList"
              :key="item.id"
              class="typeItem"
              @click="clickType(item.id)"
            >
              {{ item.program }}
              <span v-show="typeId == item.id" class="mark"></span>
            </span>
          </div>
        </div>
      </div>
      <!-- 特色服务 -->
      <div v-if="serviceIndex == 0" class="service-table f-r">
        <div class="empty" v-if="tableList1.length == 0">暂无数据</div>
        <!-- 特色服务——表格 -->
        <div
          class="tableItem f-c"
          v-for="(item, index) in tableList1"
          :key="index"
          @click="detail(item.uuid)"
        >
          <div class="tableItem-pic" :style="{ backgroundImage: `url(${item.shortPic})` }"></div>
          <div class="tableItem-con f-c">
            <div class="tableItem-title over-num-lines">{{ item.title }}</div>
            <div class="tableItem-service over-num-lines">服务商：{{ item.providerName }}</div>
            <div class="tableItem-bottom f-r">
              <span>
                <i class="el-icon-view eye"></i>
                {{ item.viewCount }}
              </span>
              <span class="type-box">{{ item.programName }}</span>
            </div>
          </div>
        </div>
        <!-- 特色服务分页 -->
        <div class="pageina" v-if="tableList1.length > 0">
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="current1"
            :page-sizes="[12, 24]"
            :page-size="pageSize1"
            layout="prev, pager, next"
            :total="total1"
          ></el-pagination>
        </div>
      </div>
      <!-- 公共服务 -->
      <div v-if="serviceIndex == 1" class="service-table f-r">
        <!-- 介绍 -->
        <!-- <div class="profile f-r">
          <div v-for="(item, index) in newsList" :key="index" class="news f-c">
            <div class="news-title">{{ item.title }}</div>
            <div class="news-summary over-num-lines num-4lines">{{ item.introduce }}</div>
          </div>
        </div>-->
        <!-- 公共服务——表格 -->
        <div class="common-wrap f-r">
          <div class="common-type">
            <div class="hotPoint">推荐排行</div>
            <div
              class="point"
              v-for="(item, index) in hotList"
              :key="index"
              @click="detail(item.uuid)"
            >{{ item.title }}</div>
          </div>
          <div class="common-table f-r">
            <div class="empty" v-if="tableList2.length == 0">暂无数据</div>
            <!-- 表格 -->
            <div
              class="commonItem f-c"
              v-for="(item, index) in tableList2"
              :key="index"
              @click="detail(item.uuid)"
            >
              <div class="commonItem-pic" :style="{ backgroundImage: `url(${item.shortPic})` }"></div>
              <div class="commonItem-title">{{ item.title }}</div>
              <div class="commonItem-summary over-num-lines num-2lines">{{ item.introduce }}</div>
              <div class="commonItem-service">{{ item.service }}</div>
            </div>
            <!-- 公共服务分页 -->
            <div class="pageina" v-if="tableList2.length > 0">
              <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="current2"
                :page-sizes="[9, 18]"
                :page-size="pageSize2"
                layout="prev, pager, next"
                :total="total2"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getDigServiceList,
  getTypeCount
} from "../../utils/interface";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      headerBgUrl: "",
      caseName: "", // 特色服务解决方案名称
      featureNum: 50, // 特色方案数量
      commonNum: 50, // 公共方案数量
      serviceIndex: 0,
      featureTypeList: [{ program: "全部" }], // 特色服务类型List
      commonTypeList: [{ program: "全部" }], // 公共服务类型List
      tableList1: [
        // {
        //   shortPic: require('../../assets/publicService/digitalize/1.png'),
        //   title: '装备制造全流程运营管控平台FOM',
        //   service: '共享智能铸造产业创新中心',
        //   viewCount: 5689,
        //   programName: '装备制造业'
        // }
      ], // 特色服务表格List
      tableList2: [
        // {
        //   shortPic: require('../../assets/publicService/digitalize/3.png'),
        //   title: '党建管理',
        //   introduce: '共享党建云，是遵循《中国共产党党章》党内相关规章制度及管理...',
        //   service: '国家智能铸造产业创新中心'
        // }
      ], // 公共服务表格List
      // 分页
      current1: 1,
      pageSize1: 12,
      total1: 0,
      current2: 1,
      pageSize2: 9,
      total2: 0,
      newsList: [
        // { title: 'HRM一体化人事管理系统', introduce: '简道云为企业提供了一体化的HRM人事管理系统，可轻松实现人事业务的全程跟踪与管理，帮助企业打造更高效的人事管理体系。' },
        // { title: '生产小工单 超轻量应用发', introduce: '生产小工单是一款简道云官方自主设计的超轻量应用，5分钟上手，3小时落地，轻松实现生产任务敏捷管理。' }
      ], // 推送消息
      hotList: [
        // { title: '员工绩效系统' },
        // { title: '汇联易' },
        // { title: '党建管理' }
      ], // 热门排行热点List
      typeId: null,
      timer: null
    };
  },
  watch: {
    serviceIndex(val) {
      // console.log('222')
      this.clickType("");
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getOptionsData();
    this.query();
    this.getSpecailService();
    this.getCommonService();
    this.getHotPoint();
    this.getNewsList();
    if (this.$route.query.type) {
      let type = this.$route.query.type;
      if (type == "special") {
        this.serviceIndex = 0;
      } else if (type == "common") {
        this.serviceIndex = 1;
      }
    }
    if (this.$route.query.title) {
      this.caseName = this.$route.query.title;
      this.$refs.search.focus();
      this.query();
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: 420,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    //顶部背景图
    getOptionsData() {
      getDictionaryItem({
        code: "SZHFWLB_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    // 点击特色服务
    clickSpecial() {
      this.serviceIndex = 0;
      // this.typeId = ''
      // this.query1('')
    },
    // 点击公共服务
    clickCommon() {
      this.serviceIndex = 1;
      // this.typeId = ''
      // this.query2('')
    },
    // 点击type
    clickType(id) {
      this.typeId = id;
      if (this.serviceIndex == 0) {
        this.query1(id);
      } else {
        this.query2(id);
      }
    },
    // 顶部查询
    query() {
      if (this.serviceIndex == 0) {
        this.query1();
      } else {
        this.query2();
      }
    },
    // 特色服务查询
    query1(uuid = "") {
      getDigServiceList({
        rec: "",
        status: "1",
        type: "SPECIAL_SERVICE",
        hot: "",
        title: this.caseName,
        current: this.current1,
        pageSize: this.pageSize1,
        programUuid: uuid
      }).then(res => {
        if (res && res.list.length > 0) {
          this.tableList1 = res.list;
          this.total1 = res.total;
        } else {
          this.tableList1 = [];
          this.total1 = 0;
        }
      });
    },
    // 公共服务查询
    query2(uuid = "") {
      getDigServiceList({
        rec: "",
        status: "1",
        type: "COMMON_SERVICE",
        hot: "",
        title: this.caseName,
        current: this.current2,
        pageSize: this.pageSize2,
        programUuid: uuid
      }).then(res => {
        if (res && res.list.length > 0) {
          this.tableList2 = res.list;
          this.total2 = res.total;
        } else {
          this.tableList2 = [];
          this.total2 = 0;
        }
      });
    },
    // 获取特色服务的分类
    getSpecailService() {
      getTypeCount({
        status: "1",
        type: "SPECIAL_SERVICE"
      }).then(res => {
        if (Object.keys(res).length > 0) {
          this.featureTypeList = res.list;
          this.featureNum = res.tatolCount;
          this.typeId = "";
        } else {
          this.featureTypeList = [];
          this.featureNum = "";
        }
        if (this.$route.query.uuid) {
          this.clickType(this.$route.query.uuid);
        }
      });
    },
    // 获取公共服务的分类
    getCommonService() {
      getTypeCount({
        status: "1",
        type: "COMMON_SERVICE"
      }).then(res => {
        if (Object.keys(res).length > 0) {
          this.commonTypeList = res.list;
          this.commonNum = res.tatolCount;
        } else {
          this.commonTypeList = [];
          this.commonNum = "";
        }
      });
    },
    // 获取热门排行
    getHotPoint() {
      getDigServiceList({
        rec: "",
        status: "1",
        type: "COMMON_SERVICE",
        hot: "1",
        title: this.caseName,
        current: "1",
        pageSize: "8"
      }).then(res => {
        if (res && res.list.length > 0) {
          this.hotList = res.list;
        } else {
          this.hotList = [];
        }
      });
    },
    // 获取顶部的2条推荐
    getNewsList() {
      getDigServiceList({
        rec: "1",
        status: "1",
        type: "COMMON_SERVICE",
        hot: "",
        title: this.caseName,
        current: "1",
        pageSize: "2"
      }).then(res => {
        if (res && res.list.length > 0) {
          this.newsList = res.list;
        } else {
          this.newsList = [];
        }
      });
    },
    // 点击进入服务详情
    detail(uuid) {
      let router = this.$router.resolve({
        path: "/digServiceDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(router.href, "_blank");
    },
    // 特色服务分页查询
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.query1();
    },
    handleCurrentChange1(val) {
      this.current1 = val;
      window.scrollTo(0, 800);
      this.query1();
    },
    // 公共服务分页查询
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.query2();
    },
    handleCurrentChange2(val) {
      console.log("222", val);
      this.current2 = val;
      window.scrollTo(0, 800);
      this.query2();
    }
  }
};
</script>
<style lang="less" scoped>
@basic-colors: #2d50a1;

.serviceList {
  position: relative;
  margin-top: -80px;
  background-color: #ffffff;

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .num-2lines {
    -webkit-line-clamp: 2;
  }

  .num-4lines {
    -webkit-line-clamp: 4;
  }

  /* flex布局，竖向分布 */
  .f-c {
    display: flex;
    flex-direction: column;
  }

  /* flex布局，横向分布 */
  .f-r {
    display: flex;
    flex-direction: row;
  }

  /* 分页 */
  .pageina {
    width: 100%;
    text-align: center;
    margin-top: 50px;

    /deep/.el-pagination button:disabled {
      background-color: transparent;
      border: 1px solid #efefef;
      border-radius: 5px;
    }

    /deep/.el-pagination .btn-prev {
      padding-right: 0;
    }

    /deep/.el-pager li {
      border: 1px solid #efefef;
      border-radius: 5px;
      margin: 0 5px;
    }

    /deep/.el-pager li.active {
      color: #fff;
      background-color: @basic-colors;
    }
  }

  /* 暂无数据 */
  .empty {
    font-size: 24px;
    font-weight: 500;
    color: #5566779e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  /* 顶部banner */
  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  /* 搜索框 */
  .serviceSearch {
    height: 100px;
    // background: url('../../assets/publicService/digitalize/26.png') no-repeat center center/100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .greatField-con-search {
      width: 990px;
      // box-shadow: 0 0 10px #9999998a;
      border: 1px solid #efefef;
      border-radius: 24px;

      .greatField-con-search-icon {
        width: 30px;
        height: 30px;
        background: url("../../assets/publicService/search.png") no-repeat
          center center/25px 26px;
      }
    }
  }

  /* 服务内容 */
  .service-con {
    width: 1300px;
    margin: 0 auto;
    min-height: 680px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 25px 0;

    .service-top {
      width: 1270px;
      height: 130px;
      border-radius: 18px;
      display: flex;

      .service-cur {
        background-color: @basic-colors;
        background-image: url("../../assets/publicService/digitalize/28.png");

        .service-top-title,
        .service-top-type {
          color: #fff !important;
        }
      }

      .service-top-item {
        width: 50%;
        height: 100%;
        padding: 15px 20px;
        box-sizing: border-box;
        font-weight: 600;
        letter-spacing: 1px;
        // box-shadow: 0 0 10px #9999998a;
        border: 1px solid #efefef;
        cursor: pointer;
        position: relative;

        &:nth-of-type(1) {
          border-top-left-radius: 16px;
          border-bottom-left-radius: 16px;
        }

        &:nth-of-type(2) {
          border-top-right-radius: 16px;
          border-bottom-right-radius: 16px;
        }

        .service-top-title {
          font-size: 24px;
          color: @basic-colors;
          width: fit-content;
        }

        /* 向下的三角形 */
        .triangle {
          position: absolute;
          width: 0;
          height: 0;
          bottom: -24px;
          left: 50%;
          transform: translateX(-50%);
          border-top: 12px solid @basic-colors;
          border-right: 12px solid transparent;
          border-left: 12px solid transparent;
          border-bottom: 12px solid transparent;
        }

        .service-top-type {
          margin-top: 20px;
          font-size: 16px;
          color: #000;
          width: fit-content;

          .typeItem {
            margin-right: 10px;
            margin-bottom: 5px;
            display: inline-block;
            position: relative;

            .mark {
              position: absolute;
              content: "";
              width: 100%;
              height: 0px;
              bottom: -8px;
              left: 50%;
              transform: translateX(-50%);
              background-color: transparent;
              border: 0px solid transparent;
              border-left: 5px solid transparent;
              border-top: 5px solid #fff;
              border-right: 5px solid transparent;
            }
          }
        }
      }
    }

    .service-table {
      width: 1300px;
      min-height: 520px;
      flex-wrap: wrap;
      justify-content: start;
      box-sizing: border-box;
      padding: 10px;
      margin-top: 20px;
      position: relative;

      .tableItem {
        width: 290px;
        height: 230px;
        // box-shadow: 0 0 10px #9999998a;
        border: 1px solid #efefef;
        box-sizing: border-box;
        border-radius: 12px;
        margin: 0 15px 20px 15px;
        cursor: pointer;

        .tableItem-pic {
          height: 145px;
          background: no-repeat center center / 100% 100%;
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
        }

        .tableItem-con {
          flex: 1;
          box-sizing: border-box;
          padding: 10px;
          justify-content: space-between;

          .tableItem-title {
            font-size: 15px;
            font-weight: bold;
          }

          .tableItem-service,
          .tableItem-bottom {
            font-size: 14px;
            color: #44556694;
            justify-content: space-between;

            .eye {
              margin-right: 5px;
            }

            .type-box {
              background-color: #2d50a11a;
              color: #2d50a1;
              // border: 1px solid #a5b1bd;
              padding: 1px 4px;
              border-radius: 6px;
            }
          }
        }
      }

      /* 公共服务——上面的 */
      .profile {
        width: 1300px;
        height: 240px;
        background: url("../../assets/publicService/digitalize/29.png")
          no-repeat center center/100% 100%;
        align-items: center;

        .news {
          width: 650px;
          height: 150px;
          border-right: 1px solid #44556630;
          box-sizing: border-box;
          padding: 0 30px;
          justify-content: start;

          &:last-child {
            border: none;
          }

          .news-title {
            font-size: 24px;
            font-weight: bold;
            color: #000;
            margin-bottom: 15px;
          }

          .news-summary {
            font-size: 16px;
            color: #000000cf;
            height: 85px;
          }
        }
      }

      /* 公共服务——底下的分类和表格 */
      .common-wrap {
        width: 1300px;
        min-height: 550px;

        .common-type {
          width: 250px;
          font-size: 22px;
          font-weight: bold;
          color: #2d50a1;
          letter-spacing: 1px;

          .hotPoint {
            position: relative;
            margin-left: 80px;

            &::before {
              position: absolute;
              content: " ";
              width: 60px;
              height: 4px;
              left: -70px;
              top: 50%;
              transform: translateY(-50%);
              background-color: #2d50a1;
            }
          }

          .point {
            position: relative;
            margin-left: 60px;
            font-size: 16px;
            color: #000;
            margin-top: 15px;

            &::before {
              position: absolute;
              content: " ";
              width: 35px;
              height: 4px;
              left: -50px;
              top: 50%;
              transform: translateY(-50%);
              background-color: #ececec;
            }

            &:hover {
              cursor: pointer;
              color: #2d50a1;
            }
          }
        }

        .common-table {
          width: 1050px;
          // box-shadow: 0 0 10px #9999998a;
          flex-wrap: wrap;
          justify-content: start;
          padding-bottom: 15px;
          position: relative;

          .commonItem {
            width: 350px;
            height: 240px;
            justify-content: space-between;
            // border-right: 1px solid #44556630;
            // border-bottom: 1px solid #44556630;
            box-sizing: border-box;
            padding: 25px 30px;
            font-weight: bold;
            cursor: pointer;

            &:nth-of-type(3n) {
              border-right: none;
            }

            .commonItem-pic {
              width: 85px;
              height: 85px;
              background: no-repeat center center/100% 100%;
            }

            .commonItem-title {
            }

            .commonItem-summary {
              font-size: 14px;
              color: #44556694;
            }

            .commonItem-service {
              font-size: 15px;
              color: #000000b5;
            }
          }
        }
      }
    }
  }
}

/* 搜索框样式 */
/deep/ .el-input-group--append .el-input__inner {
  height: 48px;
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  border: none;
}

/* 搜索图标样式 */
/deep/ .el-input-group__append {
  padding: 0 12px;
  background-color: #fff;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  border: none;

  &:hover {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/digitalize/digServiceList.vue